var _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _path21, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _path22, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _path23, _ellipse37, _ellipse38, _ellipse39, _ellipse40, _ellipse41, _ellipse42, _ellipse43, _ellipse44, _ellipse45, _ellipse46, _ellipse47, _ellipse48, _path24, _ellipse49, _ellipse50, _ellipse51, _ellipse52, _ellipse53, _ellipse54, _ellipse55, _ellipse56, _ellipse57, _ellipse58, _ellipse59, _ellipse60, _path25, _ellipse61, _ellipse62, _ellipse63, _ellipse64, _ellipse65, _ellipse66, _ellipse67, _ellipse68, _ellipse69, _ellipse70, _ellipse71, _ellipse72, _path26, _ellipse73, _ellipse74, _ellipse75, _ellipse76, _ellipse77, _ellipse78, _ellipse79, _ellipse80, _ellipse81, _ellipse82, _ellipse83, _ellipse84, _path27, _ellipse85, _ellipse86, _ellipse87, _ellipse88, _ellipse89, _ellipse90, _ellipse91, _ellipse92, _ellipse93, _ellipse94, _ellipse95, _ellipse96;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicroplate6Filled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 46,
    viewBox: "0 0 66 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 44H66L64 46H3L5 44Z",
    fill: "#99B2C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5L2 3L2.75 46L0 43V5Z",
    fill: "#D7E2EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 44L2 41L0 43L3 46L5 44Z",
    fill: "#CCD8E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 3L5 0V44L2 41V3Z",
    fill: "#F2FBFE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 44,
    transform: "translate(5)",
    fill: "#F2FBFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23445 3.73099V3.48224H9.62577V2.4896C9.48822 2.55296 9.33643 2.56704 9.18701 2.56939V2.34176C9.40283 2.33472 9.54039 2.27605 9.63763 2.13525H9.91037V3.48224H10.2993V3.73099H9.23445Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.915 3.74548V3.60233C13.915 3.30196 14.055 3.12361 14.4226 2.95465C14.6858 2.83497 14.7736 2.74345 14.7736 2.59326C14.7736 2.45481 14.6858 2.36564 14.5008 2.36564C14.3111 2.36564 14.2115 2.45716 14.2115 2.64254V2.68244H13.9411V2.61673C13.9411 2.29524 14.1427 2.12158 14.5032 2.12158C14.8661 2.12158 15.0582 2.29758 15.0582 2.59092C15.0582 2.8514 14.9206 3.01332 14.5649 3.17054C14.3087 3.28318 14.2139 3.36532 14.1996 3.49673H15.0558V3.74548H13.915Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2291 3.75948C18.8496 3.75948 18.6504 3.6046 18.6504 3.30422V3.23382H18.9255V3.26668C18.9255 3.43094 19.0251 3.51542 19.2291 3.51542C19.4188 3.51542 19.5255 3.44268 19.5255 3.27841C19.5255 3.11884 19.4307 3.04374 19.2125 3.04374H19.0465V2.79969H19.2101C19.3975 2.79969 19.49 2.73164 19.49 2.5791C19.49 2.42892 19.3975 2.35148 19.2243 2.35148C19.0417 2.35148 18.9469 2.4383 18.9469 2.59553V2.62134H18.6741V2.5791C18.6741 2.27404 18.871 2.10742 19.2315 2.10742C19.5777 2.10742 19.7722 2.2623 19.7722 2.55094C19.7722 2.7199 19.7034 2.83724 19.5611 2.89825V2.90294C19.7319 2.9663 19.8101 3.09302 19.8101 3.29014C19.8101 3.6046 19.6109 3.75948 19.2291 3.75948Z",
    fill: "#333333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.136 3.73099V3.38603H23.3486V3.13024L24.1099 2.13525H24.4206V3.14667H24.5985V3.38603H24.4206V3.73099H24.136ZM23.6356 3.14667H24.136V2.48021L23.6356 3.14667Z",
    fill: "#333333"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7073 3.74548C28.3397 3.74548 28.1381 3.58356 28.1357 3.28788H28.4109C28.418 3.42164 28.5247 3.50142 28.7049 3.50142C28.9065 3.50142 29.0133 3.40052 29.0133 3.2034C29.0133 3.00862 28.9089 2.90772 28.7192 2.90772C28.6053 2.90772 28.5152 2.94526 28.4393 3.01566H28.1832L28.2401 2.12158H29.2243V2.37033H28.482L28.4583 2.77161C28.5484 2.69886 28.6575 2.66601 28.7927 2.66601C29.1176 2.66601 29.2979 2.85374 29.2979 3.19636C29.2979 3.56478 29.0939 3.74548 28.7073 3.74548Z",
    fill: "#333333"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4625 3.75948C33.0902 3.75948 32.8862 3.57644 32.8862 3.21974V2.65654C32.8862 2.29516 33.0902 2.10742 33.472 2.10742C33.8254 2.10742 34.0057 2.267 34.0175 2.55564H33.7424C33.7305 2.42892 33.6428 2.35148 33.4697 2.35148C33.2681 2.35148 33.1708 2.45708 33.1708 2.66828V2.85601C33.2657 2.7551 33.389 2.70817 33.5503 2.70817C33.8586 2.70817 34.0341 2.88652 34.0341 3.21974C34.0341 3.57174 33.842 3.75948 33.4625 3.75948ZM33.4649 3.51542C33.657 3.51542 33.7472 3.41217 33.7472 3.22678C33.7472 3.04844 33.6618 2.95222 33.4863 2.95222C33.3368 2.95222 33.2325 3.02262 33.1708 3.16342V3.20801C33.1708 3.41217 33.2704 3.51542 33.4649 3.51542Z",
    fill: "#333333"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8549 3.73099C37.8786 3.19125 38.0897 2.74304 38.4787 2.39104H37.6201V2.13525H38.787V2.39808C38.3814 2.78528 38.1822 3.19595 38.1585 3.73099H37.8549Z",
    fill: "#333333"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.947 3.75948C42.5509 3.75948 42.3398 3.59521 42.3398 3.29484C42.3398 3.10006 42.4276 2.96865 42.6007 2.90294V2.89825C42.4561 2.83724 42.3825 2.7199 42.3825 2.55329C42.3825 2.267 42.5889 2.10742 42.9494 2.10742C43.3075 2.10742 43.5115 2.267 43.5115 2.55094C43.5115 2.7199 43.4379 2.83724 43.2933 2.89825V2.90294C43.464 2.96865 43.5541 3.10006 43.5541 3.29484C43.5541 3.59521 43.3431 3.75948 42.947 3.75948ZM42.9446 2.79734C43.1272 2.79734 43.2292 2.7199 43.2292 2.57206C43.2292 2.42422 43.1296 2.34913 42.9446 2.34913C42.7644 2.34913 42.6624 2.42422 42.6624 2.57206C42.6624 2.7199 42.7644 2.79734 42.9446 2.79734ZM42.9446 3.51777C43.1604 3.51777 43.2672 3.44033 43.2672 3.28076C43.2672 3.11884 43.1581 3.03905 42.9446 3.03905C42.7312 3.03905 42.6221 3.11884 42.6221 3.28076C42.6221 3.44033 42.7288 3.51777 42.9446 3.51777Z",
    fill: "#333333"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6783 3.75948C47.3249 3.75948 47.1423 3.5999 47.1328 3.31126H47.4079C47.4198 3.43798 47.5075 3.51542 47.6783 3.51542C47.8823 3.51542 47.9795 3.40982 47.9795 3.19862V3.00854C47.8823 3.10945 47.7589 3.15873 47.6 3.15873C47.2893 3.15873 47.1162 2.98038 47.1162 2.64716C47.1162 2.29516 47.3083 2.10742 47.6854 2.10742C48.0601 2.10742 48.2641 2.29046 48.2641 2.64716V3.21036C48.2641 3.57174 48.0601 3.75948 47.6783 3.75948ZM47.6641 2.91468C47.8159 2.91468 47.9202 2.84193 47.9795 2.69878V2.65889C47.9795 2.45473 47.8775 2.35148 47.6854 2.35148C47.4933 2.35148 47.4008 2.45473 47.4008 2.64012C47.4008 2.81846 47.4886 2.91468 47.6641 2.91468Z",
    fill: "#333333"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1078 3.75948C52.7378 3.75948 52.5386 3.57409 52.5386 3.22444V2.64246C52.5386 2.29046 52.7378 2.10742 53.1078 2.10742C53.4801 2.10742 53.6794 2.29046 53.6794 2.64246V3.22444C53.6794 3.57409 53.4801 3.75948 53.1078 3.75948ZM53.1078 3.51542C53.3046 3.51542 53.3948 3.41921 53.3948 3.21036V2.65654C53.3948 2.44769 53.3046 2.35148 53.1078 2.35148C52.9133 2.35148 52.8232 2.44769 52.8232 2.65654V3.21036C52.8232 3.41921 52.9133 3.51542 53.1078 3.51542Z",
    fill: "#333333"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2349 3.73148V3.48273H51.6263V2.49009C51.4887 2.55345 51.3369 2.56753 51.1875 2.56988V2.34225C51.4033 2.33521 51.5409 2.27654 51.6381 2.13574H51.9109V3.48273H52.2998V3.73148H51.2349Z",
    fill: "#333333"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3785 3.73099V3.48224H57.7698V2.4896C57.6323 2.55296 57.4805 2.56704 57.3311 2.56939V2.34176C57.5469 2.33472 57.6844 2.27605 57.7817 2.13525H58.0544V3.48224H58.4434V3.73099H57.3785Z",
    fill: "#333333"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9586 3.73099V3.48224H56.3499V2.4896C56.2123 2.55296 56.0605 2.56704 55.9111 2.56939V2.34176C56.127 2.33472 56.2645 2.27605 56.3618 2.13525H56.6345V3.48224H57.0235V3.73099H55.9586Z",
    fill: "#333333"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M62.022 3.74548V3.60233C62.022 3.30196 62.1619 3.12361 62.5295 2.95465C62.7928 2.83497 62.8805 2.74345 62.8805 2.59326C62.8805 2.45481 62.7928 2.36564 62.6078 2.36564C62.418 2.36564 62.3184 2.45716 62.3184 2.64254V2.68244H62.0481V2.61673C62.0481 2.29524 62.2497 2.12158 62.6101 2.12158C62.973 2.12158 63.1651 2.29758 63.1651 2.59092C63.1651 2.8514 63.0276 3.01332 62.6718 3.17054C62.4157 3.28318 62.3208 3.36532 62.3066 3.49673H63.1628V3.74548H62.022Z",
    fill: "#333333"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7232 3.74564V3.49689H61.1145V2.50425C60.977 2.56761 60.8252 2.58169 60.6758 2.58404V2.35641C60.8916 2.34937 61.0292 2.2907 61.1264 2.1499H61.3991V3.49689H61.7881V3.74564H60.7232Z",
    fill: "#333333"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17773 8.42435L5.73982 6.82861H6.03628L6.60074 8.42435H6.29242L6.1691 8.06296H5.59752L5.47182 8.42435H5.17773ZM5.67579 7.81656H6.09083L5.8845 7.16184L5.67579 7.81656Z",
    fill: "#333333"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.7436,
    cy: 7.6267,
    rx: 1.77876,
    ry: 1.76,
    fill: "#00AEEF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.4868,
    cy: 7.6267,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.2299,
    cy: 7.6267,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.9736,
    cy: 7.6267,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.7167,
    cy: 7.6267,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.4604,
    cy: 7.6267,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.2036,
    cy: 7.6267,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.9467,
    cy: 7.6267,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.6904,
    cy: 7.6267,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.4335,
    cy: 7.6267,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.1772,
    cy: 7.6267,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.9204,
    cy: 7.6267,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27979 13.1177V11.522H5.9154C6.28063 11.522 6.44665 11.651 6.44665 11.9373C6.44665 12.1133 6.38262 12.2236 6.23083 12.2776V12.2823C6.42056 12.3386 6.49883 12.463 6.49883 12.6718C6.49883 12.9793 6.33281 13.1177 5.9652 13.1177H5.27979ZM5.56913 12.1814H5.87982C6.08616 12.1814 6.15968 12.1274 6.15968 11.9749C6.15968 11.8247 6.08616 11.7707 5.88931 11.7707H5.56913V12.1814ZM5.56913 12.869H5.91777C6.13122 12.869 6.20948 12.8079 6.20948 12.6507C6.20948 12.4888 6.12648 12.4301 5.88931 12.4301H5.56913V12.869Z",
    fill: "#333333"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.7436,
    cy: 12.3201,
    rx: 1.77876,
    ry: 1.76,
    fill: "#00AEEF"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.4868,
    cy: 12.3201,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.2299,
    cy: 12.3201,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.9736,
    cy: 12.3201,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.7167,
    cy: 12.3201,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.4604,
    cy: 12.3201,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.2036,
    cy: 12.3201,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.9467,
    cy: 12.3201,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.6904,
    cy: 12.3201,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.4335,
    cy: 12.3201,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.1772,
    cy: 12.3201,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.9204,
    cy: 12.3201,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89405 17.8396C5.47901 17.8396 5.27979 17.633 5.27979 17.1989V16.8281C5.27979 16.394 5.47901 16.1875 5.89405 16.1875C6.29249 16.1875 6.48697 16.3752 6.49883 16.7671H6.21897C6.20948 16.5395 6.11462 16.4386 5.89642 16.4386C5.664 16.4386 5.56913 16.5559 5.56913 16.8328V17.1942C5.56913 17.4711 5.664 17.5885 5.89642 17.5885C6.11462 17.5885 6.20948 17.4876 6.21897 17.2623H6.49883C6.48697 17.6518 6.29249 17.8396 5.89405 17.8396Z",
    fill: "#333333"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.7436,
    cy: 17.0134,
    rx: 1.77876,
    ry: 1.76,
    fill: "#00AEEF"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.4868,
    cy: 17.0134,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.2299,
    cy: 17.0134,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.9736,
    cy: 17.0134,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.7167,
    cy: 17.0134,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.4604,
    cy: 17.0134,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.2036,
    cy: 17.0134,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.9467,
    cy: 17.0134,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.6904,
    cy: 17.0134,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.4335,
    cy: 17.0134,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.1772,
    cy: 17.0134,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.9204,
    cy: 17.0134,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28955 22.5044V20.9087H5.87061C6.29752 20.9087 6.48962 21.1058 6.48962 21.5329V21.8802C6.48962 22.3097 6.29752 22.5044 5.87061 22.5044H5.28955ZM5.5789 22.2533H5.83029C6.10067 22.2533 6.20028 22.1501 6.20028 21.8755V21.5376C6.20028 21.263 6.10067 21.1598 5.83029 21.1598H5.5789V22.2533Z",
    fill: "#333333"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.7436,
    cy: 21.7068,
    rx: 1.77876,
    ry: 1.76,
    fill: "#00AEEF"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.4868,
    cy: 21.7068,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.2299,
    cy: 21.7068,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.9736,
    cy: 21.7068,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.7167,
    cy: 21.7068,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.4604,
    cy: 21.7068,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.2036,
    cy: 21.7068,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.9467,
    cy: 21.7068,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.6904,
    cy: 21.7068,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.4335,
    cy: 21.7068,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.1772,
    cy: 21.7068,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.9204,
    cy: 21.7068,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33691 27.1978V25.6021H6.4184V25.8531H5.62626V26.2591H6.29982V26.5079H5.62626V26.9467H6.44212V27.1978H5.33691Z",
    fill: "#333333"
  })), _ellipse49 || (_ellipse49 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.7436,
    cy: 26.4001,
    rx: 1.77876,
    ry: 1.76,
    fill: "#00AEEF"
  })), _ellipse50 || (_ellipse50 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.4868,
    cy: 26.4001,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse51 || (_ellipse51 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.2299,
    cy: 26.4001,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse52 || (_ellipse52 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.9736,
    cy: 26.4001,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse53 || (_ellipse53 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.7167,
    cy: 26.4001,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse54 || (_ellipse54 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.4604,
    cy: 26.4001,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse55 || (_ellipse55 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.2036,
    cy: 26.4001,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse56 || (_ellipse56 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.9467,
    cy: 26.4001,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse57 || (_ellipse57 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.6904,
    cy: 26.4001,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse58 || (_ellipse58 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.4335,
    cy: 26.4001,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse59 || (_ellipse59 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.1772,
    cy: 26.4001,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse60 || (_ellipse60 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.9204,
    cy: 26.4001,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M5.35791 31.8911V30.2954H6.42042V30.5465H5.64726V30.9595H6.30184V31.2106H5.64726V31.8911H5.35791Z",
    fill: "#333333"
  })), _ellipse61 || (_ellipse61 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.7436,
    cy: 31.0935,
    rx: 1.77876,
    ry: 1.76,
    fill: "#00AEEF"
  })), _ellipse62 || (_ellipse62 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.4868,
    cy: 31.0935,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse63 || (_ellipse63 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.2299,
    cy: 31.0935,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse64 || (_ellipse64 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.9736,
    cy: 31.0935,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse65 || (_ellipse65 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.7167,
    cy: 31.0935,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse66 || (_ellipse66 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.4604,
    cy: 31.0935,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse67 || (_ellipse67 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.2036,
    cy: 31.0935,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse68 || (_ellipse68 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.9467,
    cy: 31.0935,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse69 || (_ellipse69 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.6904,
    cy: 31.0935,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse70 || (_ellipse70 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.4335,
    cy: 31.0935,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse71 || (_ellipse71 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.1772,
    cy: 31.0935,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse72 || (_ellipse72 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.9204,
    cy: 31.0935,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89747 36.6125C5.47768 36.6125 5.2666 36.4013 5.2666 35.9859V35.587C5.2666 35.174 5.47768 34.9604 5.88798 34.9604C6.26271 34.9604 6.4809 35.1388 6.49513 35.4838H6.21765C6.20579 35.3078 6.10381 35.2115 5.89035 35.2115C5.65793 35.2115 5.55595 35.3312 5.55595 35.6034V35.9695C5.55595 36.2417 5.6603 36.3614 5.90221 36.3614C6.13464 36.3614 6.23188 36.2511 6.23188 35.9906V35.9507H5.93067V35.6997H6.51173V35.993C6.51173 36.4107 6.31014 36.6125 5.89747 36.6125Z",
    fill: "#333333"
  })), _ellipse73 || (_ellipse73 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.7436,
    cy: 35.7869,
    rx: 1.77876,
    ry: 1.76,
    fill: "#00AEEF"
  })), _ellipse74 || (_ellipse74 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.4868,
    cy: 35.7869,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse75 || (_ellipse75 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.2299,
    cy: 35.7869,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse76 || (_ellipse76 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.9736,
    cy: 35.7869,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse77 || (_ellipse77 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.7167,
    cy: 35.7869,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse78 || (_ellipse78 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.4604,
    cy: 35.7869,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse79 || (_ellipse79 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.2036,
    cy: 35.7869,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse80 || (_ellipse80 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.9467,
    cy: 35.7869,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse81 || (_ellipse81 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.6904,
    cy: 35.7869,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse82 || (_ellipse82 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.4335,
    cy: 35.7869,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse83 || (_ellipse83 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.1772,
    cy: 35.7869,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse84 || (_ellipse84 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.9204,
    cy: 35.7869,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27051 41.2779V39.6821H5.55985V40.3368H6.21918V39.6821H6.50853V41.2779H6.21918V40.5903H5.55985V41.2779H5.27051Z",
    fill: "#333333"
  })), _ellipse85 || (_ellipse85 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.7436,
    cy: 40.4802,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse86 || (_ellipse86 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.4868,
    cy: 40.4802,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse87 || (_ellipse87 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.2299,
    cy: 40.4802,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse88 || (_ellipse88 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.9736,
    cy: 40.4802,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse89 || (_ellipse89 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.7167,
    cy: 40.4802,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse90 || (_ellipse90 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.4604,
    cy: 40.4802,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse91 || (_ellipse91 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.2036,
    cy: 40.4802,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse92 || (_ellipse92 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.9467,
    cy: 40.4802,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse93 || (_ellipse93 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.6904,
    cy: 40.4802,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse94 || (_ellipse94 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.4335,
    cy: 40.4802,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse95 || (_ellipse95 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.1772,
    cy: 40.4802,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })), _ellipse96 || (_ellipse96 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.9204,
    cy: 40.4802,
    rx: 1.77876,
    ry: 1.76,
    fill: "#99DFF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroplate6Filled);
export default __webpack_public_path__ + "static/media/microplate_6_filled.b615f54a963b746e5da360b252f88df5.svg";
export { ForwardRef as ReactComponent };